// removed by extract-text-webpack-plugin
module.exports = {"row":"_21-sGSwY198DWxp6uES6U_"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/RegListsList/RegListsList.css
// module id = 742
// module chunks = 3